import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import Default from '@/layouts/Default/Default.tsx';
import { useDefaultLayoutContext } from '@/layouts/Default/DefaultLayoutProvider.tsx';
import { Button } from 'react-daisyui';
import useSubscriptions from '@/api/useSubscriptions.ts';
import { useThemeContext } from '@/context/ThemeContext.tsx';
import AvailableThemes from '@/_constants/AvailableThemes.ts';
import Toggle from '@/components/shared/Toggle/Toggle.tsx';
import Modal from '@/components/modals/Modal/Modal.tsx';
import useClickBoard from '@/hooks/useClickboard.ts';

const HomePage: FC = () => {
  const { session } = useAuthContext();
  const { data: subscriptions } = useSubscriptions(true, { user_id: session?.user.id });
  const { setIsDrawerOpen } = useDefaultLayoutContext();
  const { activeTheme, updateTheme } = useThemeContext();
  const { copyTextToClipboard } = useClickBoard();

  const handleCopy = async () => {
    const [isSuccess, error] = await copyTextToClipboard('Text copied to clipboard');

    if (isSuccess) {
      console.log('Text copied to clipboard');
    }

    if (error) {
      console.error('Error copying text to clipboard:', error);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-link text-2xl font-bold">Home Page</h1>
      <p>{session?.user?.email}</p>
      <p>{session?.user?.id}</p>
      <div className="flex gap-2">
        <Button color="primary" onClick={handleCopy}>
          Copy to clipboard
        </Button>
        <Button color="primary" onClick={() => setIsDrawerOpen(true)}>
          Open Drawer
        </Button>
        <Button
          color="primary"
          onClick={() =>
            updateTheme(activeTheme === AvailableThemes.LIGHT ? AvailableThemes.DARK : AvailableThemes.LIGHT)
          }
        >
          Change theme
        </Button>
        <Toggle
          renderTrigger={({ toggle }) => (
            <Button color="primary" onClick={toggle}>
              Open modal
            </Button>
          )}
          renderContent={({ isOpen, handleClose }) => (
            <Modal.Wrapper
              isOpen={isOpen}
              onClose={handleClose}
              showCloseButton
              className="flex flex-col gap-4 w-[500px]"
            >
              <Modal.Title>
                <h1 className="text-2xl font-bold">Test modal</h1>
              </Modal.Title>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. As dipisci animi beatae corporis, cum
                doloremque eaque harum hic id in minima nihil nulla, obcaecati perspiciatis placeat possimus quis sed
                unde voluptatibus.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. As dipisci animi beatae corporis, cum
                doloremque eaque harum hic id in minima nihil nulla, obcaecati perspiciatis placeat possimus quis sed
                unde voluptatibus.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. As dipisci animi beatae corporis, cum
                doloremque eaque harum hic id in minima nihil nulla, obcaecati perspiciatis placeat possimus quis sed
                unde voluptatibus.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. As dipisci animi beatae corporis, cum
                doloremque eaque harum hic id in minima nihil nulla, obcaecati perspiciatis placeat possimus quis sed
                unde voluptatibus.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. As dipisci animi beatae corporis, cum
                doloremque eaque harum hic id in minima nihil nulla, obcaecati perspiciatis placeat possimus quis sed
                unde voluptatibus.
              </p>
              <Modal.Nav>
                {({ handleClose }) => (
                  <Button type="button" variant="outline" color="error" onClick={handleClose}>
                    Cancel
                  </Button>
                )}
              </Modal.Nav>
            </Modal.Wrapper>
          )}
        />
      </div>
      <h2 className="text-xl font-bold">Subscriptions:</h2>
      {subscriptions?.map((subscription) => (
        <div key={subscription.id} className="flex flex-col gap-2">
          <p>PriceID: {subscription.price_id}</p>
          <p>Ends: {subscription.current_period_end}</p>
        </div>
      )) ?? <p>No subscriptions found.</p>}
      <Default.Drawer>
        <div className="w-[300px] flex flex-col gap-4">
          <h2 className="text-xl font-bold">Drawer Content</h2>
          <p>Drawer content goes here.</p>
          <div>
            <Button color="primary" onClick={() => setIsDrawerOpen(false)}>
              Close Drawer
            </Button>
          </div>
        </div>
      </Default.Drawer>
    </div>
  );
};

export default HomePage;
